//scss
import { useRef } from "react";
import "./style.scss";

//assets
import { SvgButtonArrowLeft } from "assets/icons/js/SvgButtonArrowLeft";
import { SvgButtonArrowRight } from "assets/icons/js/SvgButtonArrowRight";

//custom hooks
import useCheckEndsReached from "customHooks/useCheckEndsReached";

const Carousel = ({ children, title = "", scrollValue = 320, theme = {} }) => {
	const listRef = useRef(null);
	const { reachedLeft, reachedRight } = useCheckEndsReached({ ref: listRef });

	return (
		<div className="carousel__wrapper">
			<h3>
				{title}
				{/* {window.innerWidth > 900 && ( */}
				<div className="carousel__arrows">
					<span
						className="button-one"
						onClick={() => (listRef.current.scrollLeft += -(scrollValue + 5))}
						style={{ cursor: "pointer" }}
					>
						{reachedLeft ? (
							<SvgButtonArrowLeft
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
							/>
						) : (
							<SvgButtonArrowRight
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
								style={{ transform: "rotate(180deg)" }}
							/>
						)}
					</span>
					<span
						className="button-two"
						onClick={() => (listRef.current.scrollLeft += scrollValue)}
						style={{ cursor: "pointer" }}
					>
						{reachedRight ? (
							<SvgButtonArrowLeft
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
								style={{ transform: "rotate(180deg)" }}
							/>
						) : (
							<SvgButtonArrowRight
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
							/>
						)}
					</span>
				</div>
				{/* )} */}
			</h3>
			<div className="carousel__items" ref={listRef}>
				{/* {list.map((Item, index) => {
					return (
						<Item
							onClick={() => onItemClick(index)}
							className="carousel__item"
						/>
					);
				})} */}
				{children}
			</div>
		</div>
	);
};

export default Carousel;
